import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { restoreQuestion } from ".";

export function useRestoreQuestion(){
    const queryClient = useQueryClient()

    return useMutation({
        mutationKey: queryKeys.question._def,
        mutationFn: restoreQuestion,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.question._def, exact: false });
        }
    });
}